export default __webpack_public_path__ + "static/core-collection-mobile-c49eda4e64926c4856f02c8ea5f56058.webp";